import { useNavigate } from 'react-router-dom';
import './index.css';
import ZendeskLink from 'components/Common/ZendeskLink';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';
import PasswordBox from './password';
import Button from 'components/Common/Button'
import { useState } from 'react';
import { SignUp } from 'store/actions/authActions';
import { useDispatch } from 'react-redux';
import { SECONDARY_BUTTON, PRIMARY_BUTTON } from 'themes/theme';


const Register = () => {
    const navigate = useNavigate();
    const [formData, SetFormData] = useState();
    // const [spinner, setSpinner] = useState(false);
    const dispath = useDispatch();
    const handleSubmit = (e) => {
        e.preventDefault();
        SignUp(formData, (val) => {}, dispath, navigate);
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        SetFormData({
            ...formData,
            [name]: value
        })
    }
    console.log('formData', formData)
    return (
        <Box padding='30px' height='100%' flexDirection='column' justifyContent='center' alignItems='center' display='flex'>
            <Box alignItems='center' className='w-100' display='flex' gap='10px' justifyContent='end'>
                <Box fontSize='14px'>Already have an account? </Box>
                <Button onClick={() => navigate('/auth')} type={SECONDARY_BUTTON}>
                    Join Now
                </Button>
            </Box>
            <h4 style={{ marginTop: '15px' }} className='authTitle'>Let's create your account</h4>
            <Box onSubmit={handleSubmit} className='mt-3' component='form'>
                <Box className="my-3 authForm" paddingX='50px'>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <label className='required' htmlFor="firstName">First Name</label>
                            <input onChange={handleChange} type="text" name='firstName' className="form-control" id="firstName" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <label className='required' htmlFor="lastName">Last Name</label>
                            <input onChange={handleChange} type="text" className="form-control" id="lastName" name='lastName' />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <label className='required' htmlFor="email">Your business email</label>
                            <input onChange={handleChange} type="email" className="form-control" id="email" name='email' />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <label className='required' htmlFor="mobile">Mobile Number</label>
                            <input onChange={handleChange} type="text" className="form-control" id="mobile" name='mobile' />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <PasswordBox onChange={handleChange} label='Create a password' name='password' />
                            <small style={{ fontSize: '12px' }} className="form-text text-muted">
                                Must be at least 8 characters and contain one uppercase letter, one
                                lowercase letter, one number and one special character (e.g., ! # $ %)
                            </small>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <PasswordBox onChange={handleChange} label='Confirm your password' name='confirmPassword' />
                        </Grid>
                        {/* <Grid item xs={12} md={12}>
                            <Box display='flex' justifyContent='center' alignItems='center' gap='10px'>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox onChange={handleChange} name='sendViaText' defaultChecked />} label={<span style={{ fontSize: '14px' }}>
                                        Send verification code via text
                                    </span>} />
                                </FormGroup>
                            </Box>

                        </Grid> */}
                    </Grid>
                </Box>
                <Box className='mt-5' display='flex' justifyContent='center'>
                    <Button type={PRIMARY_BUTTON} style={{ width: '250px' }} submit>
                        Next
                    </Button>
                </Box>
            </Box>
            <Box marginTop='auto'>
                <Box paddingX='60px' paddingY='30px' color='#66668F' textAlign='center' fontSize='12px' fontWeight={700} lineHeight='16px'>
                    By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
                    <a rel="noreferrer" className='authLink' href='https://markaaz.com/terms-and-conditions' target='_blank'>Terms and Conditions</a>,
                    including the arbitration, limitation
                    of liability, and class waiver provisions. I also confirm I have read and understand the Markaaz
                    &nbsp;<a rel="noreferrer" className='authLink' href='https://markaaz.com/privacy/' target='_blank'>Privacy Policy</a>.
                </Box>
                <ZendeskLink />
            </Box>
        </Box>
    )
};

export default Register;